import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faMobile } from '@fortawesome/free-solid-svg-icons';

interface ContactInfoProps {
  type: 'email' | 'mobile';
  label?: string;
  value: string;
}

export const ContactInfo = ({ type, label, value }: ContactInfoProps) => {
  const defaultLabel = type === 'email' ? 'Email' : 'Mobile';
  const icon = type === 'email' ? faEnvelope : faMobile;

  return (
    <div className="nova-contact-info">
      <div className="nova-contact-row">
        <span className="nova-contact-icon">
          <FontAwesomeIcon icon={icon} />
        </span>
        <div className="nova-contact-body">
          <span className="nova-contact-label">{label ?? defaultLabel}</span>
          <span className="nova-contact-value">{value}</span>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
